import pug from 'javascripts/confirmation_banner/templates/below_nav_view.jst.pug';
window.JST = window.JST || {};
window.JST['confirmation_banner/templates/below_nav_view'] = pug;
